var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:none}.cls-2{fill:#fff}.cls-2,.cls-3,.cls-4{stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:3px}.cls-4{fill:#13647b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XL_Building",
    transform: "translate(-1033 -608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_807",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(1033 608)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    transform: "translate(1066.632 632.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    transform: "translate(32.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    width: 72,
    height: 148,
    className: "cls-2",
    rx: 12.449,
    transform: "translate(-.07 .373)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(25.563 128.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.107 66.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 66.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.107 94.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 94.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    width: 19.745,
    height: 19.745,
    className: "cls-4",
    rx: 2.382,
    transform: "translate(11.107 39.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 39.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    width: 19.745,
    height: 19.745,
    className: "cls-4",
    rx: 2.382,
    transform: "translate(11.107 12.693)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 12.693)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    transform: "translate(0 11.283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    width: 72,
    height: 148,
    className: "cls-2",
    rx: 12.449,
    transform: "translate(.368 .09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(25.563 128.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.107 66.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 66.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.107 94.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 94.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.107 39.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 39.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(11.107 12.693)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    width: 19.745,
    height: 19.745,
    className: "cls-3",
    rx: 2.382,
    transform: "translate(40.019 12.693)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlBuilding);
export default __webpack_public_path__ + "static/media/xl-building.6b4ca3c0db206e816ddecec325585866.svg";
export { ForwardRef as ReactComponent };